import { Controller } from 'react-hook-form'
import { InviteAcknowledgementEditor } from './InviteAcknowledgementEditor'
import type { OrganizationEditSectionProps } from '../../types/components'

export function OrganizationApplicationTab({ ctx }: OrganizationEditSectionProps) {
  if (ctx.orgId !== 1) return null

  return (
    <div
      id="org-panel-application"
      role="tabpanel"
      aria-labelledby="org-tab-application"
      hidden={ctx.selectedTab !== 'application'}
    >
      {ctx.selectedTab === 'application' && (
        <div className="-m-4 w-[calc(100%+2rem)] bg-slate-50 p-4 sm:-m-5 sm:w-[calc(100%+2.5rem)] sm:p-5">
          <Controller
            name="rental_verification_consent_html"
            control={ctx.control}
            shouldUnregister={false}
            render={({ field: { value, onChange } }) => (
              <section className="w-full rounded-2xl border-2 border-violet-300 bg-white p-4 sm:p-6">
                <h2 className="text-xl font-semibold text-slate-900">
                  Rental Verification Form Acknowledgement and Consent
                </h2>
                <p className="mt-1 text-sm text-slate-500">
                  Body text and acknowledgement checkboxes shown when an applicant selects Rent.
                </p>
                <div className="mt-5 [&_.ck-editor__editable]:!min-h-[180px]">
                  <InviteAcknowledgementEditor
                    id="org-rental-verification-consent"
                    kind="rental"
                    value={value || ''}
                    onChange={onChange}
                  />
                </div>
              </section>
            )}
          />
        </div>
      )}
    </div>
  )
}
